import { takeEvery } from "redux-saga/effects";

import { cancelPatternConverter } from "../actions/actions";
import { donePatternConverter } from "../actions/actions";
import { CancelPatternConverter } from "./modariscomunication";
import { DonePatternConverter } from "./modariscomunication";

export default function* modariscomunicationFlow() {
  yield takeEvery(cancelPatternConverter, CancelPatternConverter);
  yield takeEvery(donePatternConverter, DonePatternConverter);
}
